// BlogPostPage.jsx
import { useParams, Link } from "react-router-dom";
import { BLOG_POSTS, getPostBySlug } from "../Components/Blog/BlogPages/Blog";
import "../Components/Blog/BlogPages/BlogPostPage.css";
import { useEffect } from "react";



export default function BlogPostPage() {
 

  const { slug } = useParams();
  const post = getPostBySlug(slug);

   useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]); 

  if (!post) {
    return (
      <div className="blog-post-wrap">
        <h1>Post not found</h1>
        <Link to="/blog" className="blog-post-back">← Back to Blog</Link>
      </div>
    );
  }

  const PostBody = post.component;
  const related = BLOG_POSTS.filter((p) => p.slug !== post.slug).slice(0, 3);

  return (
    <article className="blog-post">
      <header className="blog-post-hero">
        <div className="blog-post-heroInner">
          <Link to="/blog" className="blog-post-back">← Back to Blog</Link>
          <p className="blog-post-meta">
            <span>{post.category}</span>
            <span className="dot">•</span>
            <span>{post.author}</span>
          </p>
          <h1 className="blog-post-title">{post.title}</h1>
          <p className="blog-post-excerpt">{post.excerpt}</p>
        </div>

        <div className="blog-post-heroImageWrap">
          <img className="blog-post-heroImage" src={post.heroImage} alt={post.title} />
        </div>
      </header>

      <div className="blog-post-contentWrap">
        <div className="blog-post-content">
          <PostBody />
        </div>

        <aside className="blog-post-aside">
          <div className="blog-post-card">
            <h3>Need help buying or selling?</h3>
            <p>Let’s talk strategy and timing — no pressure.</p>
            <Link className="blog-post-cta" to="/contact">Contact Us →</Link>
          </div>

          <div className="blog-post-card">
            <h3>Related posts</h3>
            <ul className="blog-post-related">
              {related.map((r) => (
                <li key={r.slug}>
                  <Link to={`/blog/${r.slug}`}>{r.title}</Link>
                </li>
              ))}
            </ul>
          </div>
        </aside>
      </div>
    </article>
  );
}
